<div [class]="'grid-contents grid-contents--' + skeletonSize()">
    @for (_ of skeletons(); track $index) {
        <div
            class="thumbnail-skeleton"
            [class.thumbnail-skeleton--content-grid]="dimensions().isContentGrid">
            <ntv-skeleton
                width="100%"
                [height]="dimensions().previewHeight"
                [borderRadius]="dimensions().previewRadius"></ntv-skeleton>
            @if (!dimensions().isContentGrid) {
                <div class="thumbnail-skeleton__footer">
                    <ntv-skeleton
                        width="80%"
                        [height]="dimensions().titleHeight"
                        borderRadius="4px"></ntv-skeleton>
                </div>
            }
        </div>
    }
</div>
